import { initializeApp, getApps } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore, connectFirestoreEmulator } from 'firebase/firestore';
import { firebaseConfig } from './config';

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
// `settings` was renamed/deprecated in v10 — apply via `persistentLocalCache` etc.
// For ignoreUndefinedProperties, use `(db as any).settings(...)` is no longer needed in modular API
// because undefined values are ignored by default. We still call it for compatibility.
try {
  (db as any).settings?.({ ignoreUndefinedProperties: true });
} catch {
  /* noop in newer SDK */
}
export default app;
